import React, { useState, useEffect, useRef } from "react";

import * as S from "./styles";

import { Cam } from "components/shared";
interface Props {
  stop?: boolean;
}

export const Slide2: React.FC<Props> = ({ stop }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [activeVideo, setActiveVideo] = useState<boolean>(false);
  useEffect(() => {
    if (videoRef.current) {
      if (stop) {
        setActiveVideo(false);
        return videoRef.current.load();
      }
      if (activeVideo) {
        videoRef.current.play();
      } else {
        videoRef.current.load();
      }
    }
  }, [activeVideo, stop]);

  return (
    <S.Container>
      <S.Photo />
      <S.Photo2>
        <S.Credit>
          Calça, Cotton Project, R$ 359. Anéis, Quo Joias, de R$ 580 a R$ 600.
          Colar, acervo.
        </S.Credit>
        <S.ButtonVideo onClick={() => setActiveVideo(!activeVideo)}>
          <S.IconPlay />
          Video
        </S.ButtonVideo>
      </S.Photo2>
      <S.Overlay active={activeVideo}>
        <S.Video active={activeVideo}>
          <S.ButtonClose onClick={() => setActiveVideo(false)}>
            <S.IconClose />
          </S.ButtonClose>
          <Cam />
          <video
            ref={videoRef}
            muted={!activeVideo}
            autoPlay={activeVideo}
            playsInline
          >
            <source
              src="https://player.vimeo.com/external/538839136.hd.mp4?s=8e222f12395f3ef10489ce4c4dc53f2f51bcff00&profile_id=175&download=1"
              type="video/mp4"
            />
          </video>
        </S.Video>
      </S.Overlay>
      <S.Photo3>
        <S.Text>
          Calça, Cotton Project, R$ 359. Anéis, Quo Joias, de R$ 580 a R$ 600.
          Colar, acervo.
        </S.Text>
      </S.Photo3>
    </S.Container>
  );
};
